import React, { Component } from 'react';

class LeaderboardRow extends Component {
  constructor(props) {
    super(props);
  }

  splitter(string) {
    if(!string) return string;
    let splitArray = string.split('|');
    if(splitArray[0].length > 40) return splitArray[0].substring(0, 40) + '...';
    return splitArray[0];
  }

  render() {
    return(<div className="flex items-center pa2 h-10">
      <div className="w-10">
        <h3 className="ma0">{this.props.position}</h3>
      </div>
      <div className="image pr2 w-10">
        <div className="aspect-ratio aspect-ratio--1x1">
          <div 
            className="aspect-ratio--object cover br-100 z-1"
            style={{
              'backgroundImage': 'url(' + this.props.member_image + ')',
              'backgroundColor': 'green'
            }}>
          </div>
        </div>
      </div>
      <h4 className="flex flex-wrap tl">
        <div className="w-100 mb1">{this.props.member_name}</div>
        <div className="t-blue w-100">{this.splitter(this.props.score)}</div>
      </h4>
    </div>)
  }
}

export default LeaderboardRow;


// WEBPACK FOOTER //
// ./src/components/LeaderboardRow.js